module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-number",
    attrs: {
      "name": "hrms-num-input"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputNumber),
      expression: "inputNumber"
    }],
    ref: "numberInput",
    staticClass: "input-number align-center",
    class: {
      'input-error': _vm.hasError
    },
    attrs: {
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.inputNumber)
    },
    on: {
      "blur": function($event) {
        _vm.concatDecimal()
      },
      "focus": function($event) {
        _vm.setActiveInput()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputNumber = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1970ddd9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsNumInput/component.vue
// module id = 3599
// module chunks = 1